import { Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";
import { Reveal } from "@/components/site/Motion";

export default function Testimonials() {
  return (
    <section id="reviews" className="py-24 sm:py-32 bg-brand-cream">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-14">
          <div className="max-w-xl">
            <span className="overline">Social proof</span>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-brand-ink mt-4 leading-[1.02]">
              Loved by Louisiana <span className="italic text-brand-clay">neighbors.</span>
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex">{[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-brand-clay text-brand-clay" />)}</div>
            <span className="font-mono text-sm text-brand-moss">4.9 average · 200+ reviews</span>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.06}
              className="rounded-2xl border border-brand-line bg-white p-8" data-testid={`review-${i}`}>
              <div className="flex">{[...Array(t.stars)].map((_, s) => <Star key={s} className="h-4 w-4 fill-brand-sand text-brand-clay" />)}</div>
              <p className="mt-5 font-serif text-2xl leading-snug text-brand-ink">"{t.quote}"</p>
              <div className="mt-6 flex items-center gap-3">
                <div className="grid h-10 w-10 place-items-center rounded-full bg-brand-green text-brand-cream font-serif">
                  {t.name[0]}
                </div>
                <div>
                  <div className="font-medium text-brand-ink text-sm">{t.name}</div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.15em] text-brand-moss">{t.city}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
